import React, {useState} from 'react';
import {Grid, Card, CardActionArea, Button, CardContent, CardMedia, Typography, CardActions } from '@material-ui/core/';
import {Description} from '@material-ui/icons'
import BotonPersonalizado from 'components/BotonNormal'
import {useStyles} from './style';
// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';

import ModalImage from 'components/ImageModal';
import Alert from '@material-ui/lab/Alert';
import Container from '@material-ui/core/Container';

function DatosIdentidad(props) {
const classes = useStyles(),
    [activeStep, setActiveStep] = useState(0),
    [verImagen, setVerImagen] = useState(false),
    [datosImagen, setDatosImagen] = useState({image:'', title:'',}),
    [skipped, setSkipped] = useState(new Set());
const splitDate = (date) => {
    if (date !== undefined) {
        var arr1 = date.split("-");
        if(arr1[2] !== undefined){
            var arr2 = arr1[2].split("T");
            var finalDate = arr2[0] + "/" + arr1[1] + "/" + arr1[0];
        }
        return finalDate;
      }
};
const CancelarSolicitud=()=>{
    props.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD(true)
    props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step+4);    
};
const nextStep=()=>{
    props.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD(false)
    props.SOLICITUD_EMPADRONAMIENTO_SET_STEP(props.step+1);    
};
const Cerrar=()=>{
    props.data.direccion = ""
    props.data.nocasalote = ""
    props.data.zona = ""
    props.data.departamento = ""
    props.data.municipio = ""
    props.data.comunidad = ""            
    props.data.profesion = ""     
    props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(false)
    props.cerrarDialogo()
};


const VerImagen =(datosImagen)=>{
    setDatosImagen({image: datosImagen.foto, title: datosImagen.tipo})
    setVerImagen(true)
}
const CerrarVerImagen =()=>{
    setVerImagen(false)
}

return (
<div>
    { props.fotosVieneVacio ?
        <Container maxWidth="sm">
            <Alert variant="outlined" severity="error">
                {props.mensajeFotosVieneVacio}
            </Alert>
        </Container>                         
        :""
    }    
    <Grid container className={classes.rootGrid} justify="center" >
        {props.datosIdentidad.map((value, index) => (
        <Grid key={index} item>
            <Card className={classes.rootCard}>
                <CardActionArea>
                    <div className={classes.contentMedia}>
                        <CardMedia
                            style={{width:value.width, height:value.height}}
                            className={classes.media}                                
                            alt="image"
                            image={value.foto}
                            title="image"
                            onClick={()=>VerImagen(value)}
                        />
                    </div>
                    <CardContent  className={classes.cardContent}>
                        <Typography variant="subtitle1" ><strong>{value.tipo}</strong></Typography> 
                        <Typography variant="subtitle1" >{value.nombreCompletoPrueba}</Typography>
                        {/* <Typography gutterBottom variant="subtitle1" component="subtitle1">{value.nombreCompleto}</Typography><br/> */}
                        { value.fechaNacimiento ?
                            <Typography variant="subtitle1"><strong>Fecha Nacimiento:</strong> {splitDate(value.fechaNacimiento)}</Typography>
                            : ""
                        }
                    </CardContent>
                </CardActionArea>
                {/* <CardActions>
                    <Button size="small" color="primary" variant="outlined" onClick={()=>VerImagen(value)}> Ver Imagen</Button>
                </CardActions>                 */}
            </Card>                                    
        </Grid>
        ))}
        <ModalImage base64={datosImagen.image} title={datosImagen.title} open={verImagen} handleClose={CerrarVerImagen}/>
        {/* <div style={{ position: "fixed", top: "70%", right: 5 }}> */}
        <Grid item xs={12} className={classes.cardButtons}>
            <BotonPersonalizado title={"Siguiente"} botonSiguiente={true} function={nextStep}/>                                       
            <BotonPersonalizado title={"Rechazar"}  botonRechazarDocumento={true} function={CancelarSolicitud} /> 
            <BotonPersonalizado title={"Cerrar"} botonNormalCancelar={true} function={Cerrar} /> 
        </Grid>
        <div >
        </div>                        
    </Grid>  
</div>      
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(DatosIdentidad);